<template>
    <v-card
        style="min-height: 300px; position: relative; height: 100%"
        class="download"
    >
        <v-overlay absolute :opacity="0.5" z-index="100000" v-if="loading">
            <v-progress-circular indeterminate size="64">
                Loading...
            </v-progress-circular>
        </v-overlay>
        <v-form>
            <v-toolbar
                flat
                dark
                :class="screen === 'mobile' ? '' : 'pr-10 pl-10'"
                color="#2196F3"
            >
                <v-toolbar-title>
                    {{ $t("modals.savedSummaryTemplate.title") }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="$emit('popup_close')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-container
                class="pt-5"
                :class="screen === 'mobile' ? '' : 'pr-15 pl-15 pt-0'"
            >
                <v-row>
                    <v-col class="pt-0 popup__card">
                        <v-card
                            class="profile__card"
                            max-height="265"
                            min-height="265"
                        >
                            <v-card-title class="profile__card-title pl-10">
                                {{ $t("modals.download.subtitle_1") }}
                            </v-card-title>
                            <v-card-text
                                :class="screen === 'mobile' ? '' : 'pl-0 pr-0'"
                            >
                                <vue-custom-scrollbar
                                    class="scroll-area"
                                    :class="
                                        screen === 'mobile'
                                            ? 'pr-5 pl-5'
                                            : 'pr-5 pl-10'
                                    "
                                    :settings="scrlSet"
                                >
                                    <v-radio-group
                                        class="mt-0"
                                        v-model="activeTemplate"
                                    >
                                        <v-radio
                                            v-for="type in docTypes"
                                            :key="type.id"
                                            :label="type.name"
                                            :value="type"
                                        />
                                    </v-radio-group>
                                </vue-custom-scrollbar>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col class="pt-0 popup__card">
                        <v-card
                            class="profile__card"
                            max-height="265"
                            min-height="265"
                        >
                            <v-card-title
                                class="profile__card-title"
                                :class="screen === 'mobile' ? '' : 'pl-10'"
                            >
                                {{ $t("modals.download.subtitle_2") }}
                            </v-card-title>
                            <v-card-text
                                :class="screen === 'mobile' ? '' : 'pl-0 pr-0'"
                            >
                                <vue-custom-scrollbar
                                    class="scroll-area"
                                    :class="
                                        screen === 'mobile'
                                            ? 'pr-5 pl-5'
                                            : 'pr-5 pl-10'
                                    "
                                    :settings="scrlSet"
                                >
                                    <div v-html="activeTemplateText" />
                                </vue-custom-scrollbar>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row z-index="1000" bottom style="padding: 0 10px 20px 25px;">
                    <v-row align="center">{{$t('modals.savedSummaryTemplate.placeholder')}} 

                    <input
                        type="number"
                        name="relevance"
                        v-model="minRelevance"
                        class="relevance"
                    />
                    </v-row>
                    <v-spacer />
                    <button
                        class="btn btn--fill ml-auto"
                        dark
                        @click.prevent="sendSavedRequest"
                    >
                        <span>{{
                            $t("modals.savedSummaryTemplate.apply")
                        }}</span>
                    </button>
                </v-row>
            </v-container>
        </v-form>
    </v-card>
</template>
<script>
export default {
    name: "SummaryTemplate",
    props: {
        screen: String,
        scrlSet: Object,
        activeItem: Object,
        date: Object,
        digets: Object
    },
    data: () => ({
        docTypes: [],
        loading: true,
        activeTemplate: null,
        documentData: [],
        articles: [],
        minRelevance: null,
    }),
    watch:{
        minRelevance(count){
            this.minRelevance = this.minRelevance >= 0 ? this.minRelevance.replace(/\D/g, '') : 0
        }
    },
    async mounted() {
        let selectedArticles = this.$store.state.download.selectedArticles
            .length;
        let selectedTopics = this.$store.state.download.selectedTopics.length;
        if (selectedArticles) {
            this.articles.concat(selectedArticles);
        }
        if (selectedTopics) {
            this.articles.concat(selectedTopics);
        }

        this.docTypes = await this.$store.dispatch("fetchDocTypes");
        this.loading = false;
        this.activeTemplate = this.digets.templateName ? this.docTypes.find((item) => {
            return this.digets.templateName === item.name
        }) : this.docTypes[0];
        this.minRelevance = this.digets.minRelevance
    },
    computed: {
        /**
         * watch by a description text
         * */
        activeTemplateText: function () {
            if (this.docTypes.length !== 0) {
                return this.activeTemplate.description;
            }
            return "Описание отсутствует";
        },
    },
    methods: {
        /**
         * get template obj by ID
         * */
        getTemplateById(id) {
            return this.docTypes.filter(
                (type) => type.id === this.activeTemplate
            )[0];
        },
        /**
         * download file func
         * */

        getArticlesId() {
            return this.articles.map((article) => article.id);
        },
        async sendSavedRequest() {
            this.loading = true;
            let obj = Object.assign({"minRelevance": this.minRelevance >= 0 ? this.minRelevance : 0}, {}, this.activeTemplate);
            this.$emit(
                "get_template",
                obj
            );
            this.$emit("popup_close");
            this.loading = false;

        },
    },
};
</script>
<style scoped lang="scss">
.download {
    form {
        background: #fff;
    }
    .relevance{
        margin-left: 10px;  
        max-width: 130px;
        outline: none;
        border: 2px #D7D7D7 solid;
        padding: 5px;
    }
}
</style>